import React, { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { CircleLoader } from '@freelancelabs/components';

import Layout from '../app/content/Layout';
import { AppRoutes } from '../constants';

const HomePage = React.lazy(() => import('../domains/home/pages/HomePage'));
const DashboardPage = React.lazy(() => import('../domains/dashboard/pages/DashboardPage'));
const NeedsPage = React.lazy(() => import('../domains/needs/pages/NeedsPage'));
const NeedDetailPage = React.lazy(() => import('../domains/needs/pages/NeedDetailPage'));
const ServicesPage = React.lazy(() => import('../domains/activity/pages/ServicesPage'));
const ServiceDetailPage = React.lazy(() => import('../domains/activity/pages/ServiceDetailPage'));
const CompliancePage = React.lazy(() => import('../domains/activity/pages/CompliancePage'));
const ComplianceDetailPage = React.lazy(() => import('../domains/activity/pages/ComplianceDetailPage'));
const Dc4Page = React.lazy(() => import('../domains/activity/pages/Dc4Page'));
const Dc4DetailPage = React.lazy(() => import('../domains/activity/pages/Dc4DetailPage'));
const PartnersPage = React.lazy(() => import('../domains/partners/pages/PartnersPage'));
const PurchaseOrdersPage = React.lazy(() => import('../domains/purchaseOrders/pages/PurchaseOrdersPage'));
const InvoicesPage = React.lazy(() => import('../domains/invoices/pages/InvoicesPage'));
const DocumentsPage = React.lazy(() => import('../domains/documents/pages/DocumentsPage'));

const PageLoading = () => {
    return (
        <div className="flex flex-1 items-center justify-center h-full">
            <CircleLoader />
        </div>
    );
};

const lazyPage = (page: React.ReactElement) => <Suspense fallback={<PageLoading />}>{page}</Suspense>;

/**
 * Route map of the portal. Its shape follows the V2 mockup and is documented in
 * docs/architecture-front-client-hub.md: read that before adding a route.
 */
const AppRoutesTree = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<Layout />}>
                    <Route index path={AppRoutes.HOME} element={lazyPage(<HomePage />)} />
                    <Route path={AppRoutes.DASHBOARD} element={lazyPage(<DashboardPage />)} />

                    <Route path={AppRoutes.NEEDS} element={lazyPage(<NeedsPage />)} />
                    <Route path={AppRoutes.NEED_DETAIL} element={lazyPage(<NeedDetailPage />)} />

                    {/* Mon activité opens on its first tab, as in the mockup. */}
                    <Route path={AppRoutes.ACTIVITY} element={<Navigate to={AppRoutes.SERVICES} replace />} />
                    <Route path={AppRoutes.SERVICES} element={lazyPage(<ServicesPage />)} />
                    <Route path={AppRoutes.SERVICE_DETAIL} element={lazyPage(<ServiceDetailPage />)} />
                    <Route path={AppRoutes.COMPLIANCE} element={lazyPage(<CompliancePage />)} />
                    <Route path={AppRoutes.COMPLIANCE_DETAIL} element={lazyPage(<ComplianceDetailPage />)} />
                    <Route path={AppRoutes.DC4} element={lazyPage(<Dc4Page />)} />
                    <Route path={AppRoutes.DC4_DETAIL} element={lazyPage(<Dc4DetailPage />)} />

                    <Route path={AppRoutes.PARTNERS} element={lazyPage(<PartnersPage />)} />
                    <Route path={AppRoutes.PURCHASE_ORDERS} element={lazyPage(<PurchaseOrdersPage />)} />
                    <Route path={AppRoutes.INVOICES} element={lazyPage(<InvoicesPage />)} />
                    <Route path={AppRoutes.DOCUMENTS} element={lazyPage(<DocumentsPage />)} />

                    <Route path="*" element={<Navigate to={AppRoutes.HOME} />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default AppRoutesTree;
